import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

const IconButton = ({ disabled = false, onPress, style, icon, ...rest }) => {
    return (
        <Pressable disabled={disabled} onPress={onPress} style={({ pressed }) => StyleSheet.flatten(Styles.container, style, { opacity: pressed ? 0.5 : 1 })} {...rest}>
            {icon}
        </Pressable>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        borderColor: '#fff',
        borderRadius: 5,
        borderWidth: 1,
        elevation: 3,
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32
    }
});

IconButton.propTypes = {
    disabled: PropTypes.bool,
    onPress: PropTypes.func,
    style: PropTypes.object,
    icon: PropTypes.object
};

export default IconButton;
